import React, { useMemo } from 'react';
import { TrackerExtraInfo, TrackerPosition } from '@diritto/common/tracker/tracking-event.constant';
import { SectionDto } from '@diritto/common/home/dtos/section.dtos';
import { useAuthState } from 'contexts/AuthProvider';
import { useGetFancySharesInfiniteQuery } from 'queries/fancyShare/userGetFancySharesInfiniteQuery';
import { FancyShareProvider } from 'contexts/FancyShareProvider';
import { FancyShareList } from 'app-components/fancyShare/FancyShareList';
import { useHomeSettingState } from 'contexts/HomeSettingProvider';

const trackerExtraInfo: TrackerExtraInfo = {
  trackerPosition: TrackerPosition.Section,
};

export const SectionFancyShareList = ({ section }: { section: SectionDto }) => {
  const { categoryIds } = useHomeSettingState();
  const essentialCategoryIds = useMemo(
    () => (section.isEssentialVisible ? [] : categoryIds),
    [section.isEssentialVisible, categoryIds],
  );

  const { includeAdult } = useAuthState();
  const contentFancySharesQuery = useGetFancySharesInfiniteQuery({
    includeAdult,
    categoryIds: essentialCategoryIds,
  });

  return (
    <FancyShareProvider fancySharesQuery={contentFancySharesQuery}>
      <FancyShareList trackerExtraInfo={trackerExtraInfo} />
    </FancyShareProvider>
  );
};
